import { MODULE_TYPES } from 'constants/common'
import MessageTypes from 'store/actionTypes/message'
import UserTypes from 'store/actionTypes/user'
import { getTranslationMessages } from '../mapping/shared'

const initialData = {
  list: [],
  current: {},
  pagination: {},
  systems: {},
  filter: {
    [MODULE_TYPES.CIXI_CENTER]: {},
    [MODULE_TYPES.SHOWCASE_WEB]: {},
    [MODULE_TYPES.MOBILE_APP]: {}
  }
}

const label = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case MessageTypes.GET_MESSAGES_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case MessageTypes.GET_SYSTEM_MESSAGES_SUCCESS:
      return {
        ...state,
        systems: getTranslationMessages(payload?.messages?.items)
      }
    case MessageTypes.UPDATE_FILTER_MESSAGE_SUCCESS:
      return {
        ...state,
        filter: {
          ...state.filter,
          [payload?.moduleName]: payload?.data
        }
      }
    case UserTypes.LOGOUT_SUCCESS:
      return {
        ...initialData,
        systems: state.systems
      }
    default:
      return state
  }
}

export default label
